<script>
  import { PerspectiveCamera, Scene, WebGLRenderer } from 'three'
  import { onMount, setContext } from 'svelte'
  import { key, time } from './three-viz.js'
  import { writable } from 'svelte/store'
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

  let canvas
  let renderer
  let controls

  const props = writable({})

  const width = writable(window.innerWidth)
  const height = writable(window.innerHeight)
  const pixelRatio = writable(window.devicePixelRatio)

  const camera = new PerspectiveCamera(75, $width / $height, 0.1, 1000)
  const scene = new Scene()

  // let cube
  let listeners = []
  let frame

  onMount(() => {
    renderer = new WebGLRenderer({
      canvas,
      alpha: true,
    })
    renderer.setSize($width, $height)
    renderer.setPixelRatio($pixelRatio)

    camera.position.z = 8

    props.set({
      camera,
      scene,
      renderer,
      canvas,
      width: $width,
      height: $height
    })

    // render()
    // setup entities
    listeners.forEach(async entity => {
      if (entity.setup) {
        let p = entity.setup($props)
        if (p && p.then) await p
      }
      entity.ready = true
    })

    // start render loop
    return createLoop((elapsed, dt) => {
      time.set(elapsed)
      render(dt)
    })
  })

  setContext(key, {
    add(fn) {
      this.remove(fn)
      listeners.push(fn)
    },
    remove(fn) {
      const idx = listeners.indexOf(fn)
      if (idx >= 0) listeners.splice(idx, 1)
    },
  })

  function createLoop(fn) {
    let elapsed = 0
    let lastTime = performance.now()
    ;(function loop() {
      frame = requestAnimationFrame(loop)
      const beginTime = performance.now()
      const dt = (beginTime - lastTime) / 1000
      lastTime = beginTime
      elapsed += dt
      fn(elapsed, dt)
    })()
    return () => {
      cancelAnimationFrame(frame)
    }
  }

  function render(dt) {
    listeners.forEach(entity => {
      try {
        if (entity.mounted && entity.ready && entity.render) {
          entity.render($props, dt)
          renderer.render(scene, camera)
        }
      } catch (err) {
        console.error(err)
        if (killLoopOnError) {
          cancelAnimationFrame(frame)
          console.warn('Animation loop stopped due to an error')
        }
      }
    })
  }

  function handleResize() {
    width.set(window.innerWidth)
    height.set(window.innerHeight)
    pixelRatio.set(window.devicePixelRatio)
  }
</script>

<canvas
  bind:this={canvas}
  width={$width * $pixelRatio}
  height={$height * $pixelRatio}
  style="width: {$width}px; height: {$height}px;" />
<svelte:window on:resize|passive={handleResize} />
<slot />
